import ConnectWalletController from './ConnectWallet.controller';
// import CookieConsentController from './CookieConsent.controller';

const States = {
    connectWallet: new ConnectWalletController(),
    // cookieConsent: new CookieConsentController(),
};

export default States;
